export default function FoxAvatar() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_813_17342"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="0"
        width="15"
        height="16"
      >
        <path d="M15.4115 0H1V15.8752H15.4115V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_813_17342)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.4325 7.6719C13.0247 5.57545 12.7444 3.88211 12.0306 2.60533V2.59746C13.5162 3.5541 14.5954 5.0266 15.0604 6.73135C15.5253 8.4361 15.343 10.2526 14.5487 11.831C13.7544 13.4095 12.4043 14.6382 10.7582 15.2807C9.11205 15.9232 7.28645 15.9339 5.63293 15.3108C3.97939 14.6877 2.61487 13.475 1.80206 11.9061C0.989244 10.3371 0.785648 8.5228 1.23048 6.8127C1.6753 5.1026 2.73712 3.61753 4.21142 2.64346C5.68572 1.66941 7.46825 1.27523 9.2158 1.53685C8.76205 1.11014 7.8456 0.362541 6.66565 0C8.672 0 9.8722 0.852305 10.5747 1.88251L10.5973 1.89039C11.3347 3.04782 11.7716 4.53963 11.2729 6.0641C11.2053 5.0418 10.8022 4.4642 10.8022 4.4642C10.7617 5.45835 10.1705 7.0853 8.7587 7.986C8.7587 7.986 9.2023 7.1934 9.2158 6.4807C8.7857 6.9378 7.8985 7.46135 6.90095 7.60095C5.50933 7.7766 4.59395 8.5546 4.24605 9.72555C4.02877 10.4629 4.11291 11.2565 4.47998 11.9319C4.84705 12.6073 5.46707 13.1096 6.204 13.3285C7.9672 13.8531 11.0262 12.6642 12.6216 10.1759C12.0621 10.3679 11.4777 10.4779 10.8866 10.5024C12.4742 9.3247 13.2702 8.2506 13.5483 7.0121C13.2272 7.3085 12.8469 7.5334 12.4325 7.6719ZM7.55235 12.4034C7.13485 12.5126 6.6929 12.4795 6.2963 12.3095C6.148 12.2451 6.00845 12.1622 5.88085 12.0629L6.4438 11.9649L5.5577 11.6677L6.40215 11.0721L5.43724 11.0451L5.59827 10.266L5.14791 10.8525C5.0752 10.4272 5.14629 9.9898 5.34995 9.60935C5.55361 9.22895 5.87821 8.9272 6.2725 8.7519C6.6668 8.57655 7.10825 8.5376 7.52715 8.6412C7.94605 8.74475 8.31845 8.985 8.5856 9.32385C8.85275 9.66275 8.9993 10.081 9.0022 10.5125C9.0051 10.944 8.8641 11.3642 8.60155 11.7065C8.339 12.049 7.9698 12.2942 7.55235 12.4034Z"
          fill="#E75E3C"
          className="path-fill"
        />
      </g>
    </svg>
  );
}
